import { useLayoutEffect, useRef } from "react";

export function RefundBusyOverlay({ label = "İşlem tamamlanıyor…" }: { label?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  useLayoutEffect(() => {
    const dialog = ref.current!;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialog.showModal();
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
    };
  }, []);
  return <dialog ref={ref} className="refund-busy-overlay" aria-label={label} aria-busy="true" onCancel={event => event.preventDefault()}>
    <span className="refund-busy-spinner" aria-hidden="true" />
    <p role="status">{label}</p>
  </dialog>;
}
